<template>
<div id='video'>

<div class="d-none d-sm-block">
<b-row  v-for='video in videos' :key='video.id' > 

<b-col class="col-2"></b-col>
<b-col class="col-2">


<div>
  <b-embed type="iframe"  :src=video.link allowfullscreen></b-embed>
</div>

<br><br>

</b-col>
<b-col class="col-6">
<div>
  <!-- 
             <h5>Версия для десктопа</h5>
             -->
            <h2>{{video.name}}</h2>        
            <h6>{{video.text}}</h6>
</div>
</b-col>
<b-col class="col-2"></b-col>

</b-row> 

</div>



<div class="d-block d-sm-none">
<b-row  v-for='video in videos' :key='video.id' > 


<b-col class="col-12">  
<div>
  <b-embed type="iframe"  :src=video.link allowfullscreen></b-embed>
</div>
  <div>
    <!-- 
            <h5>Версия для мобильного</h5>
            -->
            <h5>{{video.name}}</h5>
            <h6>{{video.text}}</h6>
  </div>
  
</b-col>


</b-row> 
</div>




</div>
</template>




<script>

import PostsService from '@/services/PostsService';


export default {
  name: 'Video',
  data: function() {
    return {
        videos: [] , 
    };
  }, 
  
  methods: {
      async getVideos () {
      const response = await PostsService.fetchVideos()
      this.videos = response.data
       console.log(response.data);
      },

      async getNewVideos () {
      const response = await PostsService.fetchNewVideos()
      this.videos = response.data
      // console.log(response.data);
      },

     
  },



  mounted () {
    // this.getVideos()  - выводить все video, а не только новые
    // this.getNewVideos() - только новые video, у которых New ='true'
          this.getNewVideos()
  }
}

</script>





<style>

@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap');
 h1, h2, h3, h4, h5, h6 { font-family: 'Fira Sans', sans-serif; }




h3.textcenter {
   text-align: center  
}

h2.textcenter {
   text-align: center  
}

h1.textcenter {
   text-align: center  
}

</style>
